var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.0625C5.0525 17.0625 1.4375 13.4475 1.4375 9C1.4375 4.5525 5.0525 0.9375 9.5 0.9375C13.9475 0.9375 17.5625 4.5525 17.5625 9C17.5625 13.4475 13.9475 17.0625 9.5 17.0625ZM9.5 2.0625C5.675 2.0625 2.5625 5.175 2.5625 9C2.5625 12.825 5.675 15.9375 9.5 15.9375C13.325 15.9375 16.4375 12.825 16.4375 9C16.4375 5.175 13.325 2.0625 9.5 2.0625Z",
    fill: "#484C56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37703 11.6845C7.23453 11.6845 7.09203 11.632 6.97953 11.5195C6.76203 11.302 6.76203 10.942 6.97953 10.7245L11.2245 6.47953C11.442 6.26203 11.802 6.26203 12.0195 6.47953C12.237 6.69703 12.237 7.05703 12.0195 7.27453L7.77453 11.5195C7.66953 11.632 7.51953 11.6845 7.37703 11.6845Z",
    fill: "#F7F8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.622 11.6845C11.4795 11.6845 11.337 11.632 11.2245 11.5195L6.97953 7.27453C6.76203 7.05703 6.76203 6.69703 6.97953 6.47953C7.19703 6.26203 7.55703 6.26203 7.77453 6.47953L12.0195 10.7245C12.237 10.942 12.237 11.302 12.0195 11.5195C11.907 11.632 11.7645 11.6845 11.622 11.6845Z",
    fill: "#F7F8FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/Light.299eb557d98a4a10652ad8e9731d5025.svg";
export { ForwardRef as ReactComponent };